import AttemptAuthorization from '@/models/AttemptAuthorization.js';

export default {
    created() {
        if (!this.authUser) {
            throw new Error('Auth user must be defined');
        }
    },

    computed: {
        canUseAttemptAuthorization() {
            return this.userUnusedAuthorizedAttempts.length > 0;
        },

        hasAnyAttemptAuthorizations() {
            return this.userAuthorizedAttempts.length > 0;
        },

        anyAttemptAuthorizations() {
            const activityId = this.activity?.id || this.activity_id || this.activityId;

            const query = AttemptAuthorization.query().where('activity_id', activityId);

            if (!this.course || this.$gate.denies('viewAny', ['AttemptAuthorization', this.course])) {
                query.where('user_id', this.authUser.id);
            }

            return query.get();
        },

        usedAllAttemptAuthorizations() {
            return (
                this.anyAttemptAuthorizations.length !== 0 &&
                this.anyAttemptAuthorizations.length === this.usedAttemptAuthorizations.length
            );
        },

        attemptAuthorizations() {
            return this.anyAttemptAuthorizations.filter(attemptAuth => attemptAuth.used_at === null);
        },

        usedAttemptAuthorizations() {
            return this.anyAttemptAuthorizations.filter(attemptAuth => attemptAuth.used_at !== null);
        },

        userAuthorizedAttempts() {
            return this.anyAttemptAuthorizations.filter(
                authorizedAttempt => authorizedAttempt.user_id === this.authUser.id
            );
        },

        userUnusedAuthorizedAttempts() {
            return this.anyAttemptAuthorizations
                .filter(
                    authorizedAttempt =>
                        authorizedAttempt.user_id === this.authUser.id && authorizedAttempt.used_at === null
                )
                .sort((a, b) => {
                    return new Date(a.updated_at) - new Date(b.updated_at);
                });
        },

        userHasAuthorizedAttempt() {
            return this.userUnusedAuthorizedAttempts.length > 0;
        },

        attemptsRemaining() {
            return this.traditionalAttemptsRemaining + this.authorizedAttemptsRemaining;
        },

        submissionCount() {
            return this.submissions?.length || 0;
        },

        traditionalAttemptsRemaining() {
            if (this.isLate && !this.activity.activity_settings.allow_submissions_after_due_date) {
                return 0;
            }

            return Math.max(0, this.activity.activity_settings.max_attempts_allowed - this.submissionCount);
        },

        authorizedAttemptsRemaining() {
            return this.attemptAuthorizations.filter(
                authorizedAttempt => authorizedAttempt.user_id === this.authUser.id
            ).length;
        },
    },
};
